import { render, staticRenderFns } from "./FreightFiles.vue?vue&type=template&id=70ffc972"
import script from "./FreightFiles.vue?vue&type=script&lang=js"
export * from "./FreightFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Freight/FreightFiles.vue
// module id = 2306
// module chunks = 31